import { SoftButtonLink } from 'components/Button';
import { useCountryParam } from 'utils/hooks';
import { useTheme } from 'styled-components';

export const BannerRow = ({ watchlistId, mixpanelMeta }) => {
    const theme = useTheme();
    const { mutateToWithCountryParam } = useCountryParam();
    return (
        <div css="width: 100%; padding: 0 20px; display: flex; justify-content: space-between;">
            <div css="display: flex; flex-direction: column;">
                <span css="font-weight: 500">
                    Did you add related categories to your watchlist?
                </span>
                <span
                    css={`
                        font-size: 14px;
                        color: ${theme.gray_3};
                    `}
                >
                    Find related categories and brand related categories in the
                    Overview tab.
                    <SoftButtonLink
                        to={mutateToWithCountryParam(
                            `/watchlist/${watchlistId}`,
                        )}
                        mixpanelMeta={mixpanelMeta}
                        mixpanelContext="Watchlist Banner Row"
                        css="border: none; margin-left: 4px;"
                    >
                        Switch to Overview
                    </SoftButtonLink>
                </span>
            </div>
        </div>
    );
};
